import React from 'react';
interface SectionTagProps {
  children: React.ReactNode;
  className?: string;
}
export function SectionTag({
  children,
  className = ''
}: SectionTagProps) {
  return <span className={`inline-block rounded-full border border-gold/40 bg-ivory px-4 py-1.5 text-[0.65rem] font-semibold uppercase tracking-editorial text-gold-deep ${className}`} data-id="element-164" data-mp="1wr5v4s4wbv5u">
      {children}
    </span>;
}